import * as yup from 'yup';
import { dateValidation } from '../../AutoAccountWorkflow.validation';
import { BIRTH_DATE } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import {
  PARTNER_BIRTH_DATE,
  PARTNER_FIRST_NAME,
  PARTNER_LAST_NAME,
} from '../Steps/PartnerData/PartnerData';
import { TOTAL_INVESTABLE_ASSETS } from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';
import { HOW_MUCH_SAVED } from '../Steps/HowMuchSavePerMonth/HowMuchSavePerMonth';
import { WhoIsForOptionsDTO } from '../../api/useAutomatedAccountsQuery';

export const longTermValidation = yup.object().shape({
  [BIRTH_DATE]: yup.string().test('birthDate', 'Please enter a valid birth date', dateValidation),
  [PARTNER_FIRST_NAME]: yup
    .string()
    .nullable()
    .when('whoIsFor', {
      is: WhoIsForOptionsDTO.Joint,
      then: yup
        .string()
        .nullable()
        .required('Please enter a first name'),
    }),
  [PARTNER_LAST_NAME]: yup
    .string()
    .nullable()
    .when('whoIsFor', {
      is: WhoIsForOptionsDTO.Joint,
      then: yup
        .string()
        .nullable()
        .required('Please enter a last name'),
    }),
  [PARTNER_BIRTH_DATE]: yup.string().when('whoIsFor', {
    is: WhoIsForOptionsDTO.Joint,
    then: yup.string().test('partnerBirthDate', 'Please enter a valid birth date', dateValidation),
  }),
  [TOTAL_INVESTABLE_ASSETS]: yup
    .string()
    .nullable()
    .required('Please enter an amount'),
  [HOW_MUCH_SAVED]: yup
    .string()
    .nullable()
    .required('Please enter an amount'),
});
